<template>
    <div class="widget webinar-widget">
        <header class="widget-header">
            <h3><i class="fal fa-chalkboard-teacher" />Webinar</h3>
        </header>
        <div class="widget-body">
            <div class="webinar-header">
                <div class="webinar-info">
                    <span class="date">
                        <i class="far fa-calendar" />  1/4/2020
                    </span>
                    <span class="duration">
                        <i class="far fa-clock" /> 62 mins
                    </span>
                </div>
                <h3>5 Strategies to Win with Podcasting in 2021</h3>
                <div class="hosted-by">
                    <div class="host-avatar round-image">
                        <img src="/images/team/pat.png" alt="Pat Flynn">
                    </div>
                    <p>Hosted by <strong>Pat Flynn</strong></p>
                </div>
            </div>
            <div class="webinar-description">
                <p>In this workshop exclusively for Fusebox Pro Members, Pat discusses 5 tips to master your podcast this year with Q&A time throughout the session.</p>
            </div>
            <a
                v-if="user.pro"
                href="https://smartpassiveincome.wistia.com/medias/u9a11de1nf"
                class="btn"
                target="_blank"
            >Watch Replay</a>
            <a
                v-else
                href="#"
                class="btn is-green"
            >Upgrade to Pro and Register</a>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
    computed: mapState(['user']),

    methods: {
        ...mapMutations(['changeUIState']),

        /**
         * Opens upgrade modal
         *
         */
        openUpgradeModal() {
            this.changeUIState({ isUpgradeModalVisible: true });
        },
    },
};
</script>
